import { get_token, get_user_details } from "@/router";
import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import ReportCommentModal from "@/components/ReportCommentModal/ReportCommentModal.vue";
import StickyNav from "@/components/BottomNavbar/StickyNavbar.vue"
import AllGroups from "@/components/GetGroups/GroupsComponent.vue"
import UserEvents from "@/components/UserEvents/UserEvents.vue"
import CreateFeed from '@/components/CreateFeed/CreateFeed.vue'
import BusinessList from '@/components/BusinessListView/BusinessListView'
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';
import UpcomingBirthdays from '@/components/Upcoming_Birthdays/UpcomingBirthdays.vue'
import PersonalProfileList from '@/components/PersonalProfileList/PersonalProfileList.vue'
import Adverts from '@/components/Adverts/Adverts.vue'
import SurveyView from "@/components/SurveysAndPolls/Survey.vue";
import AICOne from "@/components/AICOne/FloatingOne.vue";
import { handle_audio_upload, handle_drop, handle_file_upload, view_profile as view_profile_helper } from "@/views/home/home_helper.js";
import OurWorkCard from "@/components/OurWorkCard/OurWorkCard.vue";
import { open_preview as open_file_preview } from "@/utils/file_preview";
import CreateSubject from "@/components/CreateSubject/CreateSubject.vue";
import axios from "axios";
import Comments from '@/components/Comments/Comments.vue';
import Swal from 'sweetalert2';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
const GLOBAL_URL = process.env.VUE_APP_BACKEND_API_URL;
import AllSubjects from "@/components/GetSubjects/SubjectComponent.vue";
import { view_profile_product } from "@/views/Marketplace/marketplace_helpers";
import { client_domain } from "@/main.js";
import { handle_event_list_realtime } from "@/services/eventRealtimeHandlers";
import { handle_report_realtime } from "@/services/realtime_report_helper";

export default {

  components: {
    ReportCommentModal,
    HomeNavBar,
    StickyNav,
    AllGroups,
    UserEvents,
    CreateFeed,
    BusinessList,
    InactivityModal,
    Comments,
    UpcomingBirthdays,
    PersonalProfileList,
    Adverts,
    SurveyView,
    AICOne,
    OurWorkCard,
    CreateSubject,
    Multiselect,
    AllSubjects

  },
  emits: ["update:activeTab"],
  async created() {
    this.user_details = get_user_details();
    await this.fetchReports();
    this.reportsReady = true;
  },
  computed: {

    allSelectedTags() {
      let tags = [];
      this.selected_tags.forEach(arr => {
        tags.push(...arr);
      });
      if (this.primary_tag) {
        const primaryId = this.primary_tag.id;

        tags = [
          {
            id: this.primary_tag.id,
            name: this.primary_tag.name
          },

          // all others except primary
          ...tags.filter(t => t.id !== primaryId)
        ];
      }

      return tags;
    },
    filtered_reports() {
      // 1. Determine base "source" of reports
      let sourceReports = this.reports;

      const activeTags = Array.from(this.selectedFilters.entries())
        .filter(([, selected]) => selected)
        .map(([id]) => id);

      if (activeTags.length > 0) {
        sourceReports = this.reportsByTags;
      } else {
        const activeCategories = Array.from(this.selectedCategories.entries())
          .filter(([, value]) => value)
          .map(([key]) => key);

        if (activeCategories.length > 0) {
          sourceReports = this.reportsByCategories;
        }
      }

      // 2. ❗ ONLY inject ads on marketplace domain
      if (!this.marketplace) {
        return sourceReports;
      }

      return sourceReports;
    }
  },
  mounted() {
    this.fetch_published_products();
    this.fecthsubjects();
    this.fetch_grouped_tags();
    this.fetch_library_resources();
    this.fetch_recent_uploaded();
    this.user_id = this.get_user_id();
    this.token_exists = get_token();
    const editFeedModal = $('#edit_report_modal');
    editFeedModal.on('show.bs.modal', () => {
      if (!this.isCategoryModalOpenedFromFeed) {

        this.resetSelection();

      } else {
        this.isCategoryModalOpenedFromFeed = false;
        this.reset_modal_data();
      }
    });


    if (client_domain.includes("dwypd")) {
      this.dwypd_domain = true;
    }
    if (client_domain.includes("vsi")) {
      this.vsi_domain = true;
    }
    if (client_domain.includes("chiefluthuli")) {
      this.school_domain = true;
    }
    document.addEventListener('click', this.handleClickOutside);
    if (
      this.user_details.first_time_login === "true" &&
      this.token_exists &&
      (client_domain.includes('tdm') || client_domain.includes('cbo') || client_domain.includes('chamber') || client_domain.includes('engagenet'))
    ) {
      setTimeout(() => {
        $('#company_profile_modal').modal('show');
      }, 2000);


      if (client_domain.includes('cbo')) {
        this.cbo_domain = true;
      }

    }
    if (client_domain.includes('demo') || client_domain.includes('engagenet') || client_domain.includes('apex')) {
      this.visible_domain = true;
    }
    if (client_domain.includes('vettedsa')) {
      this.marketplace = true;
    }

    if (client_domain.includes('cbo')) {
      this.cbo_domain = true;
    }

    if (client_domain.includes('soulcity') || client_domain.includes('nsp') || client_domain.includes('aicreads')) {
      this.soulcity_domain = true;
    }

    if (client_domain.includes('workbook') || client_domain.includes('engagenet')) {
      this.workbook_domain = true;
    }

    const reportId = this.$route.query.report_id; // get report_id from URL
    if (reportId) {
      this.get_report_by_id(reportId);
    }

    this._realtime_event_handler = (evt) => this.handle_realtime_event(evt);
    window.addEventListener("realtime:event", this._realtime_event_handler);

    this._realtime_report_handler = (realtime_event) =>
      this.handle_realtime_report(realtime_event);
    window.addEventListener("realtime:report", this._realtime_report_handler);

  },
  beforeUnmount() {
    if (this._realtime_event_handler) {
      window.removeEventListener("realtime:event", this._realtime_event_handler);
      this._realtime_event_handler = null;
    }
    if (this._realtime_report_handler) {
      window.removeEventListener("realtime:report", this._realtime_report_handler);
      this._realtime_report_handler = null;
    }
  },
  // beforeUnmount() {
  //   if (this.observer) {
  //     this.observer.disconnect();
  //   }

  //   document.body.removeEventListener("touchstart", this.startTouch);
  //   document.body.removeEventListener("touchmove", this.preventHorizontal);
  // },
  props: ['topic_id'],
  inject: ['client_features'],
  data() {
    return ({
      currentDate: new Date().toISOString().split('T')[0],
      linkPreview: null,
      preview_url: null,
      preview_type: null,
      loading_preview: false,
      report_edit: [],
      reports: [],
      products: [], // Added for ads integration
      report: {
        name: '', // This will bind to the input field for the report name
        description: '',
      },
      edit_authors: [],
      edit_author_input: '',  // input for author name
      edit_author_link: '',
      temporaryPost: null,
      report_id: null,
      report_description: "",
      report_name: "",
      isLoading: false,
      token_exists: false,
      user_id: null,
      edit_report_link: '',
      upcoming_events: [],
      selected_event_id: null,
      user_details: {
        "user_role": '',
        "first_name": '',
        "last_name": '',
        'user_id': '',
        "first_time_login": null

      },
      report_data: {},
      errors: {
        edit_voice_name: '',
        editFileError: null,
        editAudioError: null,
        editFileName: null,
      },
      comment_modal_visible: false,
      expandedReports: [],
      activeProfile: [],
      edit_name: '',
      edit_description: '',
      edit_documents: [],
      isRecording: false,
      audio_file: null,
      mediaRecorder: null,
      recordedChunks: [],
      audio_file_name: '',
      upload_media: null,
      audioError: '',
      editFileName: '',
      selected_topic: null,
      selectedPortalId: null,
      topics: [],
      cbo_domain: false,
      activeTab: 'normal_loans_info',
      dwypd_domain: false,
      workbook_domain: false,
      page: 1,
      page_size: 5,
      is_loading: false,
      has_more: true,
      scrollTimeout: null,
      activeCommentReportId: null,
      categories: [],
      modal_likes: [],
      reportsReady: false,
      likedReports: JSON.parse(localStorage.getItem("likedReports") || "{}"),
      library_resources: [],
      recent_uploaded: [],
      load_reports: false,
      isZoomed: false,
      soulcity_domain: false,
      selectedFilters: new Map(),
      selected_categories: [],
      selected_tags: new Map(),
      reportsByTags: [],
      reportsByCategories: [],
      subjects: [],
      selectedCategories: new Map(),
      preloadedReports: [],
      selected_report: null,
      selectedEvent: {},
      eventExtras: [],
      businessName: '',
      isFirstTime: false,
      isSubmitting: false,
      chapters: [
        "Bedfordview",
        "Edevale",
        "Kempton Park",
        "Kyalami",
        "East Rand",
      ],
      event_tickets: [],
      visible_domain: false,
      primary_tag: null,
      showAllPrimary: false,
      showAllSecondary: false,
      primary_tags: new Map(),
      isCategoryModalOpenedFromFeed: false,
      comments_off: true,
      files_to_remove: [],
      school_domain: false,
      vsi_domain: false,
      marketplace: false,
      isDragging: false,
      previews: [],
      upload_files: [],


    });
  },
  watch: {
    selectedFilters: {
      handler() {
        this.page = 1;
        this.has_more = true;
        this.reportsByTags = [];
        this.fetchReportsByTags();
      },
      deep: true
    },
    selectedCategories: {
      handler() {
        this.page = 1;
        this.has_more = true;
        this.reportsByTags = [];
        this.fetchReportsByCategory();
      },
      deep: true
    }
  },
  methods: {
    handle_realtime_event(realtime_event) {
      // Event management realtime updates (existing behavior)
      handle_event_list_realtime(this, realtime_event, { list_names: ["upcoming_events"] });
    },
    handle_realtime_report(realtime_event) {
      handle_report_realtime(this, realtime_event);
    },
    handle_drop(e) {
      handle_drop(this, e);
    },
    handleFileUpload(event) {
      handle_file_upload(event, {
        upload_files: this.upload_files,
        previews: this.previews
      });
    },
    remove_preview(index) {
      this.previews.splice(index, 1);
      this.upload_files.splice(index, 1);
    },
    open_preview(document) {
      open_file_preview(this, document);
    },

    on_content_loaded() {
      this.loading_preview = false;
    },
    markFileForRemoval(fileId, index) {
      // Add file ID to files_to_remove

      if (!this.files_to_remove
        .includes(fileId)) {
        this.files_to_remove
          .push(fileId);
      }
      // Remove visually from the list
      this.edit_documents.report_files.splice(index, 1);
    },


    get_active_profile_picture(item) {
      if (!item) return null;
      const base = item.base_profile || item;

      // PERSONAL PROFILE
      if (base.profile_type === 'personal') {
        if (base.user?.profile?.profile_files) {
          const pic = base.user.profile.profile_files.find(f => f.profile_file_type === 'profile_picture');
          return pic?.file?.url || null;
        }
      }

      // BUSINESS PROFILE
      if (base.profile_type === 'business') {
        if (base.company?.base_profile?.profile_files) {
          const logo = base.company.base_profile.profile_files[0]?.file;
          return logo?.file_url || logo?.url || null;
        }
      }

      return null;
    },

    toggle_comment(report_id) {
      // If the same report is clicked, close it
      if (this.activeCommentReportId === report_id) {
        this.activeCommentReportId = null;
      } else {
        // Otherwise open the clicked report
        this.activeCommentReportId = report_id;
      }
    },

    onActiveProfileLoaded(profile) {
      this.activeProfile = profile
    },

    reset_modal_data() {
      // tags
      this.primary_tags = new Map();
      this.selected_tags = new Map();
      this.primary_tag = null;

      // form container (if you use it)
      this.form = {};

      // report edit fields
      this.edit_name = '';
      this.edit_description = '';
      this.edit_report_link = '';
      this.report_description = '';

      // files
      this.upload_files = [];
      this.upload_media = null;
      this.audio_file = null;
      this.audio_file_name = null;
      this.files_to_remove = [];
      this.previews = [];

      // relations
      this.edit_authors = [];
      this.selected_topic = null;

      // UI state
      this.errors = {};
      this.isSubmitting = false;

      // Quill reset (important)
      if (this.$refs.quillReportRef?.getQuill) {
        this.$refs.quillReportRef.getQuill().root.innerHTML = '';
      }
    },

    handle_new_subject(new_subject) {
      this.subjects.push(new_subject);
    },
    isCategorySelected(subjectId, categoryId) {

      const safeId = String(categoryId);
      return this.selectedCategories.get(safeId) === true;
    },
    isInLibrary(fileId) {
      // Return true if the file exists in the user's library
      return this.library_resources.some(
        (doc) => doc.report_file?.file?.id === fileId
      );
    },
    toggle_library_save(file_obj) {
      if (file_obj.is_saved) {
        // unsave
        this.delete_document(file_obj.file.id);
      } else {
        // save
        this.saveToLibrary(file_obj.file.id);
      }

      // Optimistic UI update
      file_obj.is_saved = !file_obj.is_saved;
    },
    toggleCategory(subjectId, categoryId) {
      const safe_id = String(categoryId);

      const current = this.selectedCategories.get(safe_id) === true;

      this.selectedCategories.set(safe_id, !current);

      this.page = 1;
      this.has_more = true;
      this.reportsByTags = [];
      this.fetchReportsByCategory();
    },
    groupedTagsById(subjectTags) {
      const groups = new Map();

      subjectTags.forEach(st => {
        // skip if st.tag or st.tag.tag_category is undefined
        if (!st.tag || !st.tag.tag_category) return;

        const categoryId = st.tag.tag_category.id;

        if (!groups.has(categoryId)) {
          groups.set(categoryId, []);
        }
        groups.get(categoryId).push(st);
      });

      return groups;
    },
    fecthsubjects() {
      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_subjects`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          var status = response.status
          if (status === "success") {
            this.$nextTick(() => {
              this.subjects = response.subjects;
              this.isLoading = false;
            });
          }

        },

        complete: () => {
          this.isLoading = false;
        }
      });
    },
    async fetchReportsByTags() {
      if (this.is_loading || !this.has_more) return;
      this.is_loading = true;

      try {
        const activeTags = Array.from(this.selectedFilters.entries())
          .filter(([, selected]) => selected)
          .map(([id]) => id);

        const res = await axios.post(
          `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_reports_by_tags/`,
          {
            page: this.page,
            page_size: this.page_size,
            tag_ids: activeTags,
          },
          { headers: { Authorization: `Token ${this.getToken()}` } }
        );

        // 👇 Your API returns results directly, not res.data.data
        const { results, has_more, page } = res.data;

        results.forEach((report) => {
          const firstFile = report.report_files?.[0];
          report.pdf_file_url = firstFile?.file_url || "";
          report.pdf_file = firstFile || null;
          report.file_name = firstFile?.name || "";
        });

        results.forEach((newReport) => {
          if (!this.reportsByTags.some((r) => r.id === newReport.id)) {
            this.reportsByTags.push(newReport);
          }
        });

        this.page = page + 1;
        this.has_more = has_more;
      } catch (err) {
        console.error("Error fetching reports by tags:", err);
      } finally {
        this.is_loading = false;
      }
    },
    openModal(event) {
      const user_event_component = this.$refs.user_events;
      this.upcoming_events = user_event_component.upcoming_events

      const fullEvent = this.upcoming_events.find(e => e.id === event.id) || event;

      this.selectEvent(fullEvent);

      if (fullEvent.is_free) {
        $('#eventReportRsvpModal').modal('show');
      } else {
        // Ensure tickets are loaded from the full event
        this.event_tickets = (fullEvent.event_tickets || []).map(ticket => ({
          ...ticket,
          quantitySelected: 0
        }));
        $('#ticket_modal').modal('show');
      }
    },
    selectEvent(event) {
      this.selectedEvent = event;
    },
    handle_rsvp(event) {

      if (event.is_free) {

        this.fetchEvents_extras(event.id);
      } else {
        // Paid event → show ticket modal
        this.event_tickets = event.event_tickets.map(ticket => ({
          ...ticket,
          quantitySelected: 0
        }));
        $('#ticket_modal').modal('show');
      }
    },
    fetchEvents_extras(event_id) {
      this.selectEvent.id = event_id;
      this.isLoading = true;
      this.token_exists = get_token();
      this.selectedItemId = []

      // Close the event modal before making the request
      $('#eventReportRsvpModal').modal('hide');

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/get_event_data/`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: { event_id: event_id },
        success: (response_data) => {
          this.eventExtras = response_data.event_extras;
          if (this.eventExtras && this.eventExtras.length > 0) {
            $('#event_rsvp_modal').modal('show'); // Open RSVP modal
          } else {
            this.addRsvp(); // Call addRsvp if no extra details
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    addRsvp() {

      this.isSubmitting = true;
      const formData = new FormData();
      formData.append('event_id', this.selectedEvent.id);
      if (Array.isArray(this.selectedItemId)) {
        this.selectedItemId.forEach(itemId => {
          formData.append('item_id[]', itemId);
        });
      } else {
        formData.append('item_id', this.selectedItemId);
      }
      formData.append('business_name', this.businessName || '');
      formData.append('is_first_time', this.isFirstTime ? 'True' : 'False');
      formData.append('chapter', this.chapter || '');
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/add_event_rsvp/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: (response) => {
          const status = response.status;
          if (status === "success") {
            this.selectedEvent.is_rsvped = true;
            Swal.fire({
              icon: 'success',
              title: 'RSVP Successful',
              showConfirmButton: false,
              timer: 2000,
              position: 'bottom-end',
              toast: true
            }).then(() => {

              Swal.close();

              this.selectedEvent = {};
              this.businessName = '';
              $('#event_rsvp_modal').modal('hide');
            });
          }
        },
        complete: () => {
          this.isSubmitting = false;
        }

      })
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const day = date.getDate();
      const suffix = (d => {
        if (d > 3 && d < 21) return 'th';
        switch (d % 10) {
          case 1: return 'st';
          case 2: return 'nd';
          case 3: return 'rd';
          default: return 'th';
        }
      })(day);

      const weekday = date.toLocaleDateString('en-US', { weekday: 'long' });
      return `${weekday} ${day}${suffix}`;
    },
    async fetchReportsByCategory() {
      if (this.is_loading || !this.has_more) return;
      this.is_loading = true;


      try {
        const activeCategories = Array.from(this.selectedCategories.entries())
          .filter(([, value]) => value)   // keep only selected categories
          .map(([key,]) => key);


        const res = await axios.post(
          `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_reports_by_category/`,
          {
            page: this.page,
            page_size: this.page_size,
            category_ids: activeCategories
          },
          { headers: { Authorization: `Token ${this.getToken()}` } }
        );

        // 👇 Your API returns results directly, not res.data.data
        const { results, has_more, page } = res.data;

        results.forEach((report) => {
          const firstFile = report.report_files?.[0];
          report.pdf_file_url = firstFile?.file_url || "";
          report.pdf_file = firstFile || null;
          report.file_name = firstFile?.name || "";
        });

        results.forEach((newReport) => {
          if (!this.reportsByCategories.some((r) => r.id === newReport.id)) {
            this.reportsByCategories.push(newReport);
          }
        });

        this.page = page + 1;
        this.has_more = has_more;
      } catch (err) {
        console.error("Error fetching reports by tags:", err);
      } finally {
        this.is_loading = false;
      }
    },

    setActiveTab(tabName) {
      this.activeTab = tabName; // change the active tab
      this.$emit("update:activeTab", tabName);
    },
    toggleTag(tagId) {
      const safeId = String(tagId);

      // Clear all previous selections
      this.selectedFilters.forEach((value, key) => {
        this.selectedFilters.set(key, false);
      });

      // Set the clicked tag as selected
      this.selectedFilters.set(safeId, true);

      // Reset pagination and report list
      this.page = 1;
      this.has_more = true;
      this.reportsByTags = [];

      // Fetch reports
      this.fetchReportsByTags();
    },

    isTagSelected(tagId) {
      const safeId = String(tagId);
      return this.selectedFilters.get(safeId) === true;
    },
    goToFaq() {
      this.$router.push({ name: "faq" }); // Make sure your FAQ route is named 'faq'
    },
    fetch_library_resources() {
      this.load_reports = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_library_documents/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({ user_id: this.user_details?.user_id }),
        success: (response) => {
          if (response.status === "success") {
            this.library_resources = response.data;
          }
        },
        complete: () => {
          this.load_reports = false;
        }
      });
    },


    fetch_recent_uploaded() {
      this.load_reports = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_recent_uploaded/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          if (response.status === "success") {
            this.recent_uploaded = response.data;
          }
        },
        complete: () => {
          this.load_reports = false;
        }
      });
    },
    getFileClass(filename) {
      if (!filename) return "";

      const ext = filename.split('.').pop().toLowerCase();

      const map = new Map([
        ["pdf", "pdf"],
        ["doc", "doc"],
        ["docx", "doc"],
        ["xls", "xls"],
        ["xlsx", "xls"],
        ["ppt", "ppt"],
        ["pptx", "ppt"],
        ["txt", "txt"],
        ["png", "img"],
        ["jpg", "img"],
        ["jpeg", "img"]
      ]);

      return map.has(ext) ? map.get(ext) : "file";
    },

    getFileLabel(filename) {
      if (!filename) return "File";

      const ext = filename.split('.').pop().toLowerCase();

      const map = new Map([
        ["pdf", "PDF"],
        ["doc", "DOCX"],
        ["docx", "DOCX"],
        ["xls", "Excel"],
        ["xlsx", "Excel"],
        ["ppt", "PPT"],
        ["pptx", "PPT"],
        ["txt", "TXT"],
        ["png", "JPEG"],
        ["jpg", "JPEG"],
        ["jpeg", "JPEG"],
        ["csv", "CSV"],
      ]);

      return map.has(ext) ? map.get(ext) : "File";
    },
    downloadFile(file) {
      const link = document.createElement("a");
      link.href = file.url;
      link.download = file.name || "file";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    open_likes_modal(like_users) {
      this.modal_likes = like_users;
    },
    filteredCategoriesForReport(report) {
      if (!report.tags || !this.categories) return [];

      const primaryTagId = report.primary_tag?.id || null;
      // Create a Set of all tag IDs for quick lookup
      const reportTagIds = new Set(report.tags.map(t => t.id));
      if (primaryTagId) reportTagIds.add(primaryTagId);
      return this.categories
        .map(category => {
          let primaryTag = [];
          let secondaryTags = [];

          // Separate primary tag from secondary tags
          category.tags.forEach(tag => {
            if (tag.id === primaryTagId) {
              primaryTag.push({ ...tag, is_primary: true });
            } else if (reportTagIds.has(tag.id)) {
              secondaryTags.push({ ...tag, is_primary: false });
            }
          });

          const combined = [...primaryTag, ...secondaryTags];

          return {
            name: category.name,
            tags: combined
          };
        })
        .filter(category => category.tags.length > 0);
    },
    fetch_grouped_tags() {
      this.isLoading = true;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_tags/`,
        method: 'GET',
        headers: {
          Authorization: `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: response => {
          if (response.status === 'success') {
            const tag_list = response.data.tags;

            // ✅ store allowed tag ids for validation
            const grouped = new Map();

            tag_list.forEach(tag => {
              const categoryName = tag.tag_category.name;
              const categoryId = tag.tag_category.id;

              if (!grouped.has(categoryName)) {
                grouped.set(categoryName, {
                  id: categoryId,
                  tags: []
                });
              }

              grouped.get(categoryName).tags.unshift({
                id: tag.id,
                name: tag.name
              });
            });

            this.categories = Array.from(grouped.entries()).map(
              ([name, { id, tags }]) => ({
                key: name.toLowerCase().replace(/\s+/g, '-'),
                id, // ✅ category id included here
                name,
                tags
              })
            );

          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },

    handleScroll() {
      if (this.scrollTimeout) clearTimeout(this.scrollTimeout);

      this.scrollTimeout = setTimeout(() => {
        const container = this.$refs.scrollContainer;
        if (!container) return;

        const scrollBottom = container.scrollTop + container.clientHeight;
        const threshold = container.scrollHeight - 100; // fetch 100px before bottom

        if (scrollBottom >= threshold && !this.is_loading && this.has_more) {
          this.fetchReports();
        }
      }, 200); // debounce delay (200ms)
    },

    addTemporaryPost(post) {
      this.temporaryPost = post;
    },
    get_user_id() {
      const user_id = localStorage.getItem('user_id') || '';
      return user_id;
    },
    view_profile(profile) {
      view_profile_helper(this.$router,profile);
    },
    view_product_details(product) {
      if("attributes" in product){
        view_profile_product(this.$router, product);
      }
      return window.open(product.redirect_url, "_blank");
    },

    get_product_images(product) {
     const images = product.images?.filter((image) => image?.image_url) || [];
     if (images.length) {
      return images;
    }

    return (product.files?.filter((file) => file?.file?.file_url)
      .map((file) => ({
        id: file.id,
        image_url: file.file.file_url,
        file: file.file,})) || []
      );
    },
    get_ad_carousel_id(product) {
      return `home-feed-ad-carousel-${product?.unique_key || product?.id || 'unknown'}`;
    },
    baseUrl(post, type) {
      const baseUrl = `${window.location.origin}${this.$route.path}`;
      // Dynamically build the URL based on the type (either 'hub' or 'report')

      if (type === 'report') {
        return `${baseUrl}?report_id=${post.id}`;
      }
      return baseUrl
    },

    closeMenu(reportId) {
      const checkbox = document.getElementById('menu-open-' + reportId);
      if (checkbox) {
        checkbox.checked = false;
      }
    },
    resetSelection() {
      this.editFileName = '';
      this.edit_name = '';
      this.edit_description = '';
      this.edit_documents = [];
      this.edit_voice_id = null;
      this.editFileName = '';
      this.upload_media = '';
      this.audio_file = null;
      this.errors = {};
      this.comments_off = true;

    },


    handleClickOutside(event) {
      const menus = document.querySelectorAll('.menu-open');
      menus.forEach(menu => {
        if (menu.checked && !menu.closest('.menu').contains(event.target)) {
          menu.checked = false;
        }
      });
    },
    addReportToHome(newReport) {
      // Save current scroll position before DOM updates
      const container = this.$refs.scrollContainer;
      let previousScrollTop = 0;
      if (container) previousScrollTop = container.scrollTop;

      // Add the new feed
      if (!newReport.portal || newReport.portal.is_public) {
        const author_name = newReport.authors[0]?.author_name;
        newReport.author_name = author_name;
        this.reports.unshift(newReport);

        // Fetch previews for each report if needed
        this.reports.forEach((report) => {
          if (report.report_link) {
            this.fetchReportPreview(report);
          }
        });
        this.fetch_recent_uploaded()
      }

      this.temporaryPost = null;

      // Restore scroll position after DOM updates
      this.$nextTick(() => {
        if (container) container.scrollTop = previousScrollTop;
      });
    },



    getFileIcon(fileUrl) {
      const url = fileUrl || ''; // default to empty string if undefined or null

      if (url.includes('.pdf'))
        return 'https://cdn-icons-png.flaticon.com/128/337/337946.png'; // PDF icon
      if (url.includes('.doc') || url.includes('.docx'))
        return 'https://cdn-icons-png.flaticon.com/128/337/337932.png'; // Word icon
      if (url.includes('.xls') || url.includes('.xlsx'))
        return 'https://cdn-icons-png.flaticon.com/128/337/337958.png'; // Excel icon
      if (url.includes('.ppt') || url.includes('.pptx'))
        return 'https://cdn-icons-png.flaticon.com/128/337/337950.png'; // PowerPoint icon

      return 'https://cdn-icons-png.flaticon.com/128/337/337940.png'; // Default file icon
    },
    getFileName(fileUrl) {
      const decodedUrl = decodeURIComponent(fileUrl);
      const cleanUrl = decodedUrl.split('?')[0];
      return cleanUrl.substring(cleanUrl.lastIndexOf('/') + 1);
    },
    getToken() {
      return get_token();
    },
    deleteReport(report_id) {
      if (!this.token_exists) {
        this.$router.push('/sign_in_finale');
        return;
      }
      Swal.fire({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        position: 'bottom-end',
        toast: true
      }).then((result) => {
        if (result.isConfirmed) {
          $.ajax({
            type: "DELETE",
            url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_report_api/`,
            data: JSON.stringify({ report_id: report_id }),
            headers: {
              'Authorization': `Token ${this.getToken()}`,
              'Content-Type': 'application/json'
            },
            success: (response) => {
              const status = response.status;
              if (status === "success") {
                this.reports = this.reports.filter(report => report.id !== report_id);
                Swal.fire({
                  title: 'Deleted!',
                  text: 'The feed has been deleted.',
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 1000,
                  position: 'bottom-end',
                  toast: true
                })
              } else {
                Swal.fire({
                  title: 'Failed!',
                  text: response.message || 'An error occurred. Please try again.',
                  icon: 'error',
                  position: 'bottom-end',
                  showConfirmButton: false,
                  timer: 3000,
                  toast: true
                });
              }
              this.fetch_recent_uploaded();
              this.fetch_library_resources();
            },
            error: () => {
              Swal.fire({
                title: 'Failed!',
                text: 'An error occurred. Please try again.',
                icon: 'error',
                position: 'bottom-end',
                showConfirmButton: false,
                timer: 3000,
                toast: true
              });
            }
          });
        }
      });
    },
    fetchReportPreview(report) {

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/fetch_url_meta/`,
        type: 'POST',
        data: { url: report.report_link },
        headers: { Authorization: `Token ${get_token()}` },
        success: (data) => { report.linkPreview = data; },
      });
    },
    get_report_by_id(report_id) {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_report_by_id/`,
        method: 'POST',
        data: { report_id: report_id },
        success: (response) => {
          if (response.status === 'success') {
            const report = response.reports[0];
            this.display_comment_modal(report);
          }
        },
        error: () => {
          if (this.soulcity_domain) {
            window.location = "/";
            return;
          }
        },
      });
    },
    fetch_published_products() {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/ads_management/get_published_products/`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        success: (response) => {
          if (response.status === "success" && response.data) {
            this.products = response.data.map((p) => ({ ...p, is_ad: true }));
          }
        },
        error: (xhr, status, error) => {
          console.error("Error fetching published products:", {
            status,
            error,
            responseText: xhr?.responseText,
          });
        },
      });
    },
    hide_ad(product_id, base_profile_id) {
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/ads_management/hide_ad/`,
        method: "POST",
        headers: {
          Authorization: `Token ${this.getToken()}`,
          "Content-Type": "application/json",
        },
        data: JSON.stringify({ product_id: product_id, base_profile_id: base_profile_id }),
        success: (response) => {
          if (response.status === "success") {
            this.products = this.products.filter((p) => p.id !== product_id);
          }
        },
        error: (xhr, status, error) => {
          console.error("Error hiding product:", {
            status,
            error,
            responseText: xhr?.responseText,
          });
        },
      });
    },

    async fetchReports() {
      if (this.is_loading || !this.has_more) return;

      this.is_loading = true;

      const headersConfig = {
        headers: {
          Authorization: `Token ${this.getToken()}`
        },
      };
      try {
        let results;

        // 1️⃣ Use preloaded reports if available
        if (this.preloadedReports?.length) {
          results = this.preloadedReports;
          this.preloadedReports = []; // clear after using
          this.page += 1;
        } else {
          // fallback to normal fetch
          const res = await axios.post(
            `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/filter_reports_api/`,
            {
              user_id: this.user_details?.user_id,
              page: this.page,
              page_size: this.page_size,
            },
            headersConfig
          );

          if (res.data.status === "success" && res.data.data) {
            results = res.data.data.results;
            this.has_more = res.data.data.has_more;
            this.page = res.data.data.page + 1;
          }
        }

        if (results?.length) this.processReports(results);

        // Preload next page in background
        if (this.has_more) this.preloadNextPage();

      } catch (err) {
        console.error("Error fetching reports:", err);
      } finally {
        this.is_loading = false;
      }
    },


    processReports(results) {
      results.forEach((report) => {
        const firstFile = report?.report_files?.[0];
        report.authors = report?.authors || [];
        report.pdf_file_url = firstFile?.file_url || "";
        report.pdf_file = firstFile || null;
        report.file_name = firstFile?.name || "";
      });

      // Prevent duplicates
      const newReports = results.filter(r => !this.reports.some(existing => existing.id === r.id));
      this.reports.push(...newReports);

      // Check if saved in library
      newReports.forEach(report => {
        report?.report_files?.forEach(fileObj => {
          fileObj.is_saved = this.library_resources?.some(doc => doc?.report_file?.file.id === fileObj?.file.id);
        });
      });

      // Fetch link preview if missing
      this.reports.forEach(report => {
        if (!report.linkPreview && report.report_link) {
          report.linkPreview = null;
          this.fetchReportPreview(report);
        }

      });
    },

    async preloadNextPage() {
      const nextPage = this.page;

      try {
        const res = await axios.post(
          `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/filter_reports_api/`,
          {
            user_id: this.user_details?.user_id,
            page: nextPage,
            page_size: this.page_size,
          },
          { headers: { Authorization: `Token ${this.getToken()}` } }
        );

        if (res.data.status === "success" && res.data.data) {
          this.preloadedReports = res.data.data.results;
          this.has_more = res.data.data.has_more;
        }
      } catch (err) {
        console.error("Error preloading next page:", err);
        this.preloadedReports = [];
      }
    },

    togglePinReport(report) {
      const newPinStatus = !report.is_pinned;

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/pin_report_api/`,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          post_id: report.id,
          is_pinned: newPinStatus
        }),
        success: (response) => {
          if (response.status === 'success') {
            report.is_pinned = newPinStatus;

            // Only move to top if pinned
            if (newPinStatus) {
              const index = this.reports.indexOf(report);
              if (index > -1) {
                this.reports.splice(index, 1); // remove from current position
              }
              this.reports.unshift(report); // add to top
            }
          }
        },
      });
    },
    display_comment_modal(report_data) {
      this.report_data = report_data;
      this.comment_modal_visible = true;
    },

    handleAudioUpload(event) {
      const audio_upload = handle_audio_upload(event);

      this.audio_file = audio_upload.file;
      this.audio_file_name = audio_upload.file_name;
      this.audioError = audio_upload.error;
    },

    startRecording() {
      navigator.mediaDevices.getUserMedia({ audio: true })
        .then((stream) => {
          this.mediaRecorder = new MediaRecorder(stream);

          this.mediaRecorder.ondataavailable = (event) => {
            if (event.data.size > 0) {
              this.recordedChunks.push(event.data);
            }
          };

          this.mediaRecorder.onstop = () => {
            const audioBlob = new Blob(this.recordedChunks, { type: 'audio/wav' });
            this.audio_file = audioBlob;
            this.audio_file_name = 'recording.wav';
          };

          this.mediaRecorder.start();
          this.isRecording = true;
        })
        .catch((error) => {
          if (error.name === 'NotAllowedError') {
            Swal.fire({
              icon: 'error',
              title: 'Microphone Access Denied',
              text: 'Please allow microphone access in your browser settings and refresh the page.',
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: `Error accessing microphone: ${error.message}`,
              position: 'bottom-end',
              showConfirmButton: false,
              timer: 3000,
              toast: true
            });
          }
        });
    },

    stopRecording() {
      if (this.mediaRecorder && this.isRecording) {
        this.mediaRecorder.stop();
        this.isRecording = false;
      }
    },

    fetch_topics(portal_id) {

      this.isLoading = true;
      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_all_topics_api`,
        method: 'GET',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: { portal_id: portal_id },
        success: (response) => {
          var status = response.status
          if (status == "success") {
            this.topics = response.topics
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    },
    onPortalChange() {
      if (this.selectedPortalId) {
        this.fetch_topics(this.selectedPortalId);
      }
    },

    openEditCategoryModal(report) {
      // Hide the edit report modal
      $('#edit_report_modal').modal('hide');

      // Populate primary tags
      if (report.primary_tag) {
        const categoryId = report.primary_tag.tag_category.id;
        this.primary_tags.set(categoryId, report.primary_tag);
      }
      $('#category_modal_edit').modal('show');
    },

    openEditAuthorModal() {
      $('#edit_report_modal').modal('hide');
      $('#author_modal_edit').modal('show');
    },
    addAuthor() {
      const name = this.edit_author_input.trim();
      const link = this.edit_author_link.trim() || '';

      if (!name) return;

      // Push to edit_authors array
      if (!this.edit_authors) this.edit_authors = [];
      this.edit_authors.push({
        author_name: name,
        author_link: link
      });

      // Clear inputs
      this.edit_author_input = '';
      this.edit_author_link = '';
    },

    removeAuthor(index) {
      this.edit_authors.splice(index, 1);
    },
    saveEditAuthors() {
      this.report_edit.authors = this.edit_authors;

      $('#author_modal_edit').modal('hide');
      $('#edit_report_modal').modal('show');
    },
    updateTagSelection(categoryId, selectedTags) {
      this.selected_tags.set(categoryId, selectedTags);
    },

    submit_tags() {
      // Start with secondary tags
      let allSelected = Array.from(this.selected_tags.values()).flat();

      // Add primary tags if they exist and not already in secondary
      this.primary_tags.forEach((tag) => {
        if (!allSelected.find(t => t.id === tag.id)) {
          allSelected.push({ id: tag.id, name: tag.name });
        }
      });

      // Save to selected_categories
      this.selected_categories = allSelected;

    },


    selectPrimaryTag(categoryId, tag) {
      //  Get old primary BEFORE modifying the map
      this.primary_tags.clear();
      const oldPrimary = this.primary_tags.get(categoryId) || null;

      // Update primary tag only for this category
      this.primary_tags.set(categoryId, tag || null);
      this.primary_tag = tag || null;

      // 3️⃣ Refresh secondary tags for THIS category
      let secondaryTags = this.selected_tags.get(categoryId) || [];

      // Remove the new primary from secondary
      if (tag) {
        secondaryTags = secondaryTags.filter(t => t.id !== tag.id);
      }

      // Remove the old primary from secondary
      if (oldPrimary) {
        secondaryTags = secondaryTags.filter(t => t.id !== oldPrimary.id);
      }

      this.selected_tags.set(categoryId, secondaryTags);

      this.primary_tags = new Map(this.primary_tags);
      this.selected_tags = new Map(this.selected_tags);
    },

    edit_report(report) {
      this.report_edit = report;
      this.edit_authors = report.authors;
      this.edit_author_input = this.edit_selected_author;
      const TextDescription = report.description;
      this.edit_report_link = report.report_link;
      this.report_id = report.id;
      this.edit_documents = report;
      this.selectedPortalId = report.portal?.id || '';
      this.selected_topic = report.topic?.id || '';
      this.selected_categories = report.tags?.map(tag => tag.tag_category) || [];
      this.comments_off = report.can_comment;

      // Initialize Maps
      this.primary_tags = new Map();
      this.selected_tags = new Map();

      // Set primary tag if exists
      if (report.primary_tag) {
        const catId = report.primary_tag.tag_category.id;
        this.primary_tags.set(catId, report.primary_tag);
        this.primary_tags = new Map(this.primary_tags); // reactive
        this.primary_tag = report.primary_tag; // <-- THIS is what was missing

      }

      // Prefill tags per category
      if (report.tags && Array.isArray(report.tags)) {
        report.tags.forEach(tag => {
          const catId = tag.tag_category.id;
          if (!this.selected_tags.has(catId)) this.selected_tags.set(catId, []);

          const catTags = this.selected_tags.get(catId);

          // If this tag is primary, add to front; else push normally
          if (report.primary_tag && tag.id === report.primary_tag.id) {
            catTags.unshift({
              id: tag.id,
              name: tag.name
            });
          } else {
            catTags.push({
              id: tag.id,
              name: tag.name
            });
          }

          this.selected_tags.set(catId, catTags);
        });
      }


      this.onPortalChange();

      this.$nextTick(() => {
        const quillEditor = this.$refs.quillReportRef.getQuill();
        if (quillEditor) {
          quillEditor.clipboard.dangerouslyPasteHTML(TextDescription);

          quillEditor.root.addEventListener('paste', (e) => {
            const pastedText = e.clipboardData.getData('text');
            const match = pastedText.match(/(https?:\/\/[^\s]+)/g);
            if (match && match[0]) {
              report.report_link = match[0]; // update report object
              this.previewLink(report);
              this.edit_report_link = match[0];
            }
          });
        }
      });
    },

    previewLink(report) {

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/fetch_url_meta/`,
        type: 'POST',
        data: { url: report.report_link },
        headers: { Authorization: `Token ${get_token()}` },
        success: (data) => { this.report_edit.linkPreview = data; },
      });
    },
    edit_report_data() {
      Swal.fire({
        title: 'Submitting...',
        text: 'Please wait while we process your request.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      this.isSubmitting = true;
      const formData = new FormData();

      this.report_description = this.$refs.quillReportRef.getQuill().root.innerHTML.trim();
      formData.append('description', this.report_description);
      formData.append('can_comment', this.comments_off);
      formData.append('report_id', this.report_id);
      formData.append('authors', JSON.stringify(this.edit_authors))
      if (this.edit_report_link) {
        formData.append('report_link', this.edit_report_link);
      }
      if (this.upload_media) {
        formData.append('file', this.upload_media);
      }
      if (this.audio_file) {
        formData.append('file', this.audio_file, this.audio_file_name);
      }
      if (this.selected_topic) {
        formData.append('topic_id', this.selected_topic);
      }

      this.files_to_remove.forEach(id => {
        formData.append('remove_file_ids', id);
      });



      const tagIds = [];
      this.selected_tags.forEach(tagsArray => {
        tagsArray.forEach(tag => tagIds.push(tag.id));
      });

      tagIds.forEach(id => formData.append('tag_ids', id));

      // Only one primary tag
      if (this.primary_tag) {
        formData.append('primary_tag_id', this.primary_tag.id);
      };
      this.upload_files.forEach(file => {
        formData.append('file', file);
      });
      $.ajax({
        type: 'POST',
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/update_report_api/`,
        data: formData,
        processData: false,
        contentType: false,
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        success: (response) => {
          if (response.status === 'success') {
            const updatedReport = response.updated_data;
            const author_name = updatedReport.authors[0]?.author_name;
            updatedReport.author_name = author_name;
            updatedReport.report_link = this.edit_report_link;
            updatedReport.total_comments = updatedReport.total_comments || 0;

            const reportIndex = this.reports.findIndex(
              (hub) => hub.id === updatedReport.id
            );

            if (reportIndex !== -1) {
              this.reports.splice(reportIndex, 1, updatedReport);
              updatedReport.linkPreview = this.report_edit.linkPreview;
            }

            Swal.fire({
              icon: 'success',
              title: response.message,
              showConfirmButton: false,
              timer: 1000,
              position: 'bottom-end',
              toast: true
            }).then(() => {
              this.reset_modal_data();
              $('#edit_report_modal').modal('hide');
            });
          }
        },
        error: (response) => {
          Swal.close();
          const response_data = response.responseJSON;
          this.errors.edit_name = response_data.message;
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },
    hide_comment_comment() {
      this.report_data = {};
      this.comment_modal_visible = false;
    },














    likeReport(report) {
      if (!this.token_exists) {
        this.$router.push('/sign_in_finale');
        return;
      }

      const reportId = report.id;

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_report_like/`,
        contentType: "application/json",
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: JSON.stringify({ report_id: reportId }),
        success: (response) => {
          if (response.status === "success") {
            const liked_report = this.reports.find(r => r.id === reportId);

            if (liked_report) {
              // ✅ Increment like counts
              liked_report.like_count++;
              liked_report.total_likes = (liked_report.total_likes || 0) + 1;

              // ✅ Add current user to report.likes (for modal)
              const currentUser = {
                user: {
                  id: this.user_details.user_id,
                  first_name: this.user_details.first_name,
                  last_name: this.user_details.last_name,
                  profile_picture: this.user_details.profile_picture || null,
                  is_blocked: false
                }
              };

              // Prevent duplicates
              const alreadyLiked = liked_report.likes.some(
                (u) => u.user && u.user.id === this.user_details.user_id
              );

              if (!alreadyLiked) {
                liked_report.likes.push(currentUser);
              }

              // ✅ Reassign reports array to trigger reactivity
              this.reports = [...this.reports];
            }

            // ✅ Save locally liked report IDs
            if (
              (typeof reportId === 'number' && Number.isInteger(reportId)) ||
              (typeof reportId === 'string' && /^[a-zA-Z0-9_-]+$/.test(reportId))
            ) {
              Reflect.set(this.likedReports, reportId, true);
              localStorage.setItem("likedReports", JSON.stringify(this.likedReports));
            } else {
              console.warn('Invalid reportId:', reportId);
            }
          }
        }
      });
    },


    unlikeReport(report) {
      if (!this.token_exists) {
        this.$router.push('/sign_in_finale');
        return;
      }

      const reportId = report.id;

      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_report_like/`,
        contentType: "application/json",
        headers: {
          'Authorization': `Token ${this.getToken()}`,
        },
        data: JSON.stringify({ report_id: reportId }),
        success: (response) => {
          if (response.status === "success") {
            const unliked_report = this.reports.find(r => r.id === reportId);
            if (unliked_report) {
              if (unliked_report.like_count > 0) {
                unliked_report.like_count--;   // update like count shown on each report
              }
              if (unliked_report.total_likes > 0) {
                unliked_report.total_likes--; // update global total likes
              }

              // Remove current user from the likes array (if present)
              try {
                const currentUserId = String(this.user_details.user_id);
                if (Array.isArray(unliked_report.likes)) {
                  const idx = unliked_report.likes.findIndex(u => u && u.user && String(u.user.id) === currentUserId);
                  if (idx !== -1) {
                    unliked_report.likes.splice(idx, 1);
                  }
                }

                // Ensure modal list is synced if it was opened
                if (Array.isArray(this.modal_likes) && this.modal_likes.length) {
                  this.modal_likes = this.modal_likes.filter(u => !(u && u.user && String(u.user.id) === currentUserId));
                }
              } catch (err) {
                console.warn('Error removing user from likes:', err);
              }

              // Reassign reports to trigger reactivity
              this.reports = [...this.reports];
            }

            // Validate reportId before setting
            if (
              (typeof reportId === 'number' && Number.isInteger(reportId)) ||
              (typeof reportId === 'string' && /^[a-zA-Z0-9_-]+$/.test(reportId))
            ) {
              Reflect.set(this.likedReports, reportId, false);
              localStorage.setItem("likedReports", JSON.stringify(this.likedReports));
            } else {
              console.warn('Invalid reportId:', reportId);
            }
          }
        }
      });
    },








    handleCopy(report) {
      const link = this.baseUrl(report, 'report');;

      navigator.clipboard.writeText(link).then(() => {
        Swal.fire({
          toast: true,
          position: 'top-center',
          icon: 'success',
          title: 'Link copied!',
          showConfirmButton: false,
          timer: 1800,
          timerProgressBar: true,
        });
      }).catch(() => {
        Swal.fire({
          toast: true,
          position: 'top-center',
          icon: 'error',
          title: 'Copy failed',
          showConfirmButton: false,
          timer: 1800,
        });
      });
    },







    async submit_comment(report_id) {
      if (!this.token_exists) {
        this.$router.push('/sign_in_finale');
        return;
      }

      const comment_text = $("#comment_text_area").val();

      if (comment_text.trim() === "") {
        Swal.fire({
          icon: 'error',
          title: 'Please write a comment before submitting.',
          timer: 2000,
          showConfirmButton: false,
        });
        return;
      }

      const baseUrl = `${window.location.origin}${this.$route.path}?report_id=${report_id}`;
      this.commentText = "";
      $("#comment_text_area").val("");

      const request_data = {
        report_id,
        comment_text,
        base_url: baseUrl
      };

      const request_url = `${GLOBAL_URL}/portal_management/add_report_comment/`;

      $.ajax({
        url: request_url,
        method: 'POST',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(request_data),
        success: (response) => {
          if (response.status === "success") {
            const newComment = response.data.comment_data;

            // ✅ Find the report in parent state
            const reportIndex = this.reports.findIndex(r => r.id === report_id);
            const report = this.reports.at(reportIndex); // safer access

            if (report) {
              // ✅ Replace comments array so Vue notices the change
              report.comments = [newComment].concat(report.comments);

              // ✅ Increment total_comments
              report.total_comments = (report.total_comments || 0) + 1;

              // ✅ Replace parent reports array for top-level reactivity
              this.reports = Array.from(this.reports);
            }

            // Clear input
            this.commentText = "";
            $("#comment_text_area").val("");
          }
        },
        error: () => {
          Swal.fire({
            icon: 'error',
            title: 'Could not add comment',
            text: 'Please try again later.',
            timer: 3000,
            showConfirmButton: false,
            position: 'bottom-end',
            toast: true
          });
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    },
    handleAddComment({ report_id, newComment }) {
      const reportIndex = this.reports.findIndex(r => r.id === report_id);
      const report = this.reports.at(reportIndex); // ✅ safe accessor

      if (report) {
        report.comments = [newComment].concat(report.comments);
        this.reports = Array.from(this.reports); // ✅ reactivity trigger
      }
    },
    isExpanded(reportId) {
      return this.expandedReports.includes(reportId);
    },
    toggleDescription(reportId) {
      if (this.isExpanded(reportId)) {
        this.expandedReports = this.expandedReports.filter(id => id !== reportId);
      } else {
        this.expandedReports.push(reportId);
      }
    },
    displayedDescription(report) {
      if (!report.description) return '';
      // Clean description by removing the report link if present
      let cleanDesc = report.description;
      if (report.report_link && report.linkPreview) {
        cleanDesc = cleanDesc.split(report.report_link).join("").trim();
      }
      return cleanDesc;
    },

    saveToLibrary(file_id) {

      if (!this.token_exists) {
        this.$router.push('/sign_in_finale');
        return;
      }
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/add_library_document/`,
        data: JSON.stringify({ report_file_id: file_id, user_id: this.user_details?.user_id }),
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          if (response.status === "success") {
            this.library_resources.unshift(response.data)
            this.reports?.forEach(report => {
              report?.report_files?.forEach(fileObj => {
                if (fileObj?.file?.id === file_id) {
                  fileObj.is_saved = true;
                }
              });
            });
          }
        },
      });
    },

    delete_document(file_id) {

      // Find library_document id for this file_id
      const libraryDoc = this.library_resources.find(doc => doc.report_file.file.id === file_id);

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/delete_library_document/`,
        method: 'DELETE',
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({ library_document_id: libraryDoc.id }),
        success: (response) => {
          if (response.status === "success") {
            this.library_resources = this.library_resources.filter(doc => doc.id !== libraryDoc.id);

            this.reports.forEach(report => {
              report?.report_files?.forEach(fileObj => {
                if (fileObj.file.id === file_id) {
                  fileObj.is_saved = false;
                }
              });
            });
          }
        },
      });
    },
    open_event_modal(report_id) {
      const user_event_component = this.$refs.user_events;
      this.upcoming_events = user_event_component.upcoming_events
      this.selected_report = report_id
      $('#report_event').modal('show')
    },
    link_event_report() {
      $.ajax({
        type: "POST",
        url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/assign_report_event/`,
        data: JSON.stringify({ report_id: this.selected_report, event_id: this.selected_event_id }),
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        success: (response) => {
          if (response.status === "success") {

            this.selected_event_id = null,
              this.selected_report = null
            $('#report_event').modal('hide')
          }
        },
      });
    },
    isWithinRSVPPeriod(event) {
      const now = new Date();
      const start = new Date(`${event.rsvp_start_date}T${event.rsvp_start_time}`);
      const end = new Date(`${event.rsvp_end_date}T${event.rsvp_end_time}`);
      if (now < start) {
        return ({ isValid: false, message: "RSVP has not started yet." });
      }
      if (now > end) {
        return ({ isValid: false, message: "RSVP period has ended." });
      }
      return ({ isValid: true, message: "" });
    },
    process_to_checkout() {

      const selectedTickets = this.event_tickets
        .filter(t => t.quantitySelected > 0)
        .map(t => ({
          ticket_id: t.id,
          quantity: t.quantitySelected,

        }));
      if (selectedTickets.length === 0) {
        Swal.fire({
          title: "No tickets selected",
          text: "Please choose at least one ticket.",
          icon: "warning",
          position: 'bottom-end',
          showConfirmButton: false,
          timer: 3000,
          toast: true
        });
        return;
      }


      const request_data = {
        event_id: this.selectedEvent.id,
        user_id: this.user_details.user_id,
        tickets: selectedTickets
      };

      $.ajax({
        url: `${process.env.VUE_APP_BACKEND_API_URL}/event_management/ticket_purchase_api/`,
        method: "POST",
        headers: {
          'Authorization': `Token ${this.getToken()}`,
          'Content-Type': 'application/json'
        },
        data: JSON.stringify(request_data),
        success: (response) => {
          if (response.status === "success") {

            const orderData = response.data;
            $('#ticket_modal').modal('hide'); $('.modal-backdrop').remove();
            this.$router.push({ name: 'checkout', params: { order_id: orderData.id } });

          }
        },
        error: (xhr) => {
          Swal.fire({
            title: "Error",
            text: "Failed to create order.",
            icon: "error",
            position: 'bottom-end',
            showConfirmButton: false,
            timer: 3000,
            toast: true
          });
          console.error("AJAX error:", xhr.responseText);
        }
      });

    },

    isImageReportFile(fileObj) {
      const url = String(fileObj?.file?.url || fileObj?.file?.file_url || '').split('?')[0];
      return /\.(jpe?g|png|avif|webp)$/i.test(url);
    },

    getCarouselImages(report) {
      const files = Array.isArray(report?.report_files) ? report.report_files : [];
      return files.filter((item) => this.isImageReportFile(item));
    },

    getNonImageReportFiles(report) {
      const files = Array.isArray(report?.report_files) ? report.report_files : [];
      return files.filter((item) => !this.isImageReportFile(item));
    },
    get_cta_label(advertisement) {
      const url = String(advertisement?.redirect_url || "").toLowerCase();
      const title = String(advertisement?.title || "").toLowerCase();
      const description = String(advertisement?.description || "").toLowerCase();
      const combined = `${url} ${title} ${description}`;

      if (/(apply|career|job|vacancy|recruit)/.test(combined)) return "Apply now";
      if (/(sign up|register|join|premium|subscribe)/.test(combined)) return "Sign up";
      if (/(shop|buy|order|sale)/.test(combined)) return "Shop now";
      return "Learn more";
    },
    get_ads_button_info(report){
      if("attributes" in report){
        return "View Products"
      }
      return this.get_cta_label(report)
    },
  }
}
